import { computed } from "vue";
import { ConfirmModalStoreModule } from "./modules/confirmModalStore";
import store from ".";

/**
 * Состояние модуля ConfirmModalStoreModule
 * @returns 
 */
export const useConfirmModalStore = () => {
  if (!store.hasModule('confirmModal')) store.registerModule('confirmModal', ConfirmModalStoreModule);

  return {
    modals: computed(() => store.state.confirmModal.modals),
    open: (payload) => store.dispatch('confirmModal/open', payload),
    close: (payload) => store.dispatch('confirmModal/close', payload),
  };
};
